import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";
import classNames from "classnames";
import { NovartisPatientSupportSVG } from "../assets/images/novartisPatienSupport";
import { useTranslation } from "@nvs/gatsby-theme-leap-core/src/hooks";
import { RichText } from "@nvs/gatsby-theme-leap-core/src/components/hoc/components";

const ConfirmationSupport: React.FC = () => {
  const { t } = useTranslation();
  const data = useStaticQuery(
    graphql`
      {
        file(dir: { regex: "/images/" }) {
          childImageSharp {
            gatsbyImageData(placeholder: NONE)
          }
        }
      }
    `
  );

  return (
    <div
      className={classNames(
        "grid grid-cols-1 max-w-2xl items-center justify-center gap-9"
      )}
    >
      {data.file && (
        <div className="flex flex-col gap-2">
          <GatsbyImage
            className="w-auto rounded-2xl"
            imgClassName="print:w-full"
            image={getImage(data.file)}
            alt={t("pages.confirmation.novartis.patient.support.img.alt")}
            loading="eager"
          />

          <p className="text-xs">
            <RichText
              html={t(
                "pages.confirmation.novartis.patient.support.img.disclaimer"
              )}
            />
          </p>
        </div>
      )}
      <div className="flex flex-col gap-5">
        <NovartisPatientSupportSVG className="max-w-[275px]" />
        <p>
          <RichText
            html={t("pages.confirmation.service.adherence.comprehensive")}
          />
        </p>
      </div>
    </div>
  );
};
export default ConfirmationSupport;
